export default class PvApiUnprocessableEntityException extends Error {
    constructor(_response = null) {
        super();
        this.name = '422 unprocessable entity';
        this.message = 'Проверка данных завершилась неудачно';
        this.response = _response;
    }
}